<div class="flex-row justify-center items-center h-100">
    <div class="flex-gt-sm-30 flex-lt-sm-80">
        <mat-card appearance="outlined" class="p-0 mat-elevation-z6 box">
            <div class="flex-col justify-center items-center bg-primary box-header">
                <mat-icon class="mat-icon-xlg">error</mat-icon>
                <h1 class="error">404</h1>
            </div>
            <mat-card-content class="flex-col justify-end items-center box-content">
                    <p class="box-text">Opps, it seems that this page does not exist.</p> 
                    <p class="box-text">If you are sure it should, search for it.</p> 
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Search keyword</mat-label>
                        <input matInput placeholder="Enter search keyword...">
                    </mat-form-field>
            </mat-card-content>
            <mat-card-actions class="flex-row space-between">
                <button mat-icon-button color="primary" class="mat-elevation-z8" type="button" (click)="goHome()">
                    <mat-icon>home</mat-icon>
                </button>
                <button mat-icon-button color="primary" class="mat-elevation-z8" type="button" (click)="goHome()">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>          
    </div>
</div>